// extracted by mini-css-extract-plugin
module.exports = {"shopPage":"Style_shopPage__3ReHC","regisButton0":"Style_regisButton0__vFs7h","regisButton1":"Style_regisButton1__2-usj"};